import { render, staticRenderFns } from "./SKUName.vue?vue&type=template&id=322c82e6&scoped=true&"
import script from "./SKUName.vue?vue&type=script&lang=js&"
export * from "./SKUName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322c82e6",
  null
  
)

export default component.exports